import { base } from "./base";
import { errorToastHook } from "./hooks/(beforeError)/errorToast";
import { loaderEndHook } from "./hooks/(afterResponse)/loaderEnd";
import { loaderErrorHook } from "./hooks/(beforeError)/loaderError";
import { loaderStartHook } from "./hooks/(beforeRequest)/loaderStart";
import { refreshWorkflowTokenHook } from "./hooks/(afterResponse)/refreshWorkflowToken";
import { workflowAuthHook } from "./hooks/(beforeRequest)/authWorkflow";

// Workflow-authenticated instance — loader + workflow token + workflow 403 refresh
export const httpWorkflowAuth = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, refreshWorkflowTokenHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, workflowAuthHook],
  },
});
